// import React, { useContext } from "react";
// // import Card from "../components/Card";
// import { ThemeContext } from "../themeProvider";
// import { ProjectsData } from "../constants";
// import { motion } from "framer-motion";
// // import { techStack } from "../constants";

// const Projects = () => {
//   const theme = useContext(ThemeContext);
//   const darkMode = theme.state.darkMode;

//   return (
//     <div
//       id="projects"
//       className={darkMode ? "bg-gray-100 text-black" : "bg-gray-700"}
//     >
//       <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4  pt-24 pb-12">
//         <h2 className={darkMode? "text-5xl font-bold px-4 md:px-0 text-center": "text-5xl font-bold px-4 md:px-0 text-center text-white"}>
//           PROJECTS
//         </h2>
//         <h4 className="mt-16 text-3xl font-semibold text-blue-600">
//           What I Build
//         </h4>
//         {/* flex flex-wrap mt-8 flex flex-wrap justify-between  */}
//         <div
//           className=""
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr 1fr",
//             justifyContent: "space-between",
//           }}
//         >
//           {ProjectsData.map((el) => (
//             <motion.div
//               initial="hidden"
//               whileInView={"visible"}
//               variants={{
//                 visible: {
//                   y: 0,
//                   opacity: 1,
//                   transition: {
//                     type: "spring",
//                   },
//                 },
//                 hidden: { opacity: 1, y: 80 },
//               }}
//               // md:w-48 w-40
//               className="py-2 px-4 bg-gray-50 md:m-2 mx-2 mt-3 rounded-lg  items-center hover:scale-125 cursor-pointer "
//             >
//               <img
//                 alt=""
//                 src={el.img}
//                 className="w-12"
//                 style={{ width: "100%", border: "1px solid green" }}
//               />
//               <h4
//                 className=" ml-4"
//                 style={{
//                   color: "yellowgreen",
//                   fontWeight: "bold",
//                   textAlign: "center",
//                   fontSize: "28px",
//                 }}
//               >
//                 {el.name}
//               </h4>
//               <p>{el.desc}</p>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   margin: "20px",
//                 }}
//               >
//                 {el?.tech.map((newele) => (
//                   <p
//                     style={{
//                       marginRight: "10px",
//                       padding: "5px",
//                       fontWeight: "bold",
//                       textTransform: "capitalize",
//                     }}
//                   >
//                     {newele}
//                   </p>
//                 ))}
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   gridGap: "10px",
//                   paddingLeft: "4%",
//                   alignItems: "center",
//                 }}
//               >
//                 <button className=" bg-blue-700  py-2 px-4 md:m-2 mx-2 mt-3 rounded-lg   hover:scale-125 cursor-pointer">
//                   {
//                     <a href={el.code} target="_blank" rel="noreferrer">
//                       Code{" "}
//                     </a>
//                   }
//                 </button>
//                 <button className=" bg-blue-700   py-2 px-4 md:m-2 mx-2 mt-3 rounded-lg   hover:scale-125 cursor-pointer ">
//                   {" "}
//                   {
//                     <a href={el.demo} target="_blank" rel="noreferrer">
//                       Demo{" "}
//                     </a>
//                   }
//                 </button>
//                 {/* py-2 px-4 md:m-2 mx-2 mt-3 rounded-lg   hover:scale-125 cursor-pointer */}
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Projects;


import React, { useContext } from "react";
import { ThemeContext } from "../themeProvider";
import { ProjectsData } from "../constants";
import { motion } from "framer-motion";

const Projects = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      id="projects"
      className={darkMode ? "bg-gray-100 text-black" : "bg-gray-700 text-white"}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center">
          PROJECTS
        </h2>
        <h4 className="mt-16 text-3xl font-semibold text-blue-600">
          What I Build
        </h4>
        <div
          className="grid gap-4 mt-8"
          style={{
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          }}
        >
          {ProjectsData.map((el, index) => (
            <motion.div
              key={index}
              initial="hidden"
              whileInView="visible"
              variants={{
                visible: {
                  y: 0,
                  opacity: 1,
                  transition: { type: "spring" },
                },
                hidden: { opacity: 1, y: 80 },
              }}
              className="py-2 px-4 bg-gray-50 md:m-2 mx-2 mt-3 rounded-lg items-center hover:scale-105 cursor-pointer"
            >
              <img
                alt=""
                src={el.img}
                className="w-full"
                style={{ border: "1px solid green" }}
              />
              <h4
                className="mt-4"
                style={{
                  color: "yellowgreen",
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "1.75rem",
                }}
              >
                {el.name}
              </h4>
              <p>{el.desc}</p>
              <div className="flex flex-wrap items-center mt-4">
                {el?.tech.map((newele, techIndex) => (
                  <p
                    key={techIndex}
                    style={{
                      marginRight: "10px",
                      padding: "5px",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                    }}
                  >
                    {newele}
                  </p>
                ))}
              </div>
              <div className="flex gap-2 mt-4">
                <button className="bg-blue-700 py-2 px-4 rounded-lg hover:scale-105 cursor-pointer">
                  <a href={el.code} target="_blank" rel="noreferrer">
                    Code
                  </a>
                </button>
                <button className="bg-blue-700 py-2 px-4 rounded-lg hover:scale-105 cursor-pointer">
                  <a href={el.demo} target="_blank" rel="noreferrer">
                    Demo
                  </a>
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
